import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import FlattenedSign from '../flattened/sign.js';

var CompactSign = /*#__PURE__*/function () {
  function CompactSign(payload) {
    _classCallCheck(this, CompactSign);

    this._flattened = new FlattenedSign(payload);
  }

  _createClass(CompactSign, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      this._flattened.setProtectedHeader(protectedHeader);

      return this;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        var jws;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._flattened.sign(key, options);

              case 2:
                jws = _context.sent;

                if (!(jws.payload === undefined)) {
                  _context.next = 5;
                  break;
                }

                throw new TypeError('use the flattened module for creating JWS with b64: false');

              case 5:
                return _context.abrupt("return", "".concat(jws.protected, ".").concat(jws.payload, ".").concat(jws.signature));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return CompactSign;
}();

export { CompactSign };
export default CompactSign;